module.exports = __webpack_public_path__ + "img/couple.b230f2ad.jpg";